import * as models from "app/models/requireme";
import * as kea from "kea-react";
import { formatDate } from "kea-react";

type Entity = models.ManifiestosCargaDescargaRADView;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Fecha", cell: x => ({ data: kea.formatDate(x.Fecha+"")  }) },
    { title: "Tipo", cell: x => ({ data: x.Tipo }) },
    { title: "Folio Guia", cell: x => ({ data: x.FolioGuia }) },
    { title: "Sucursal Origen", cell: x => ({ data: x.SucursalOrigen }) },
    { title: "Sucursal Destino", cell: x => ({ data: x.SucursalDestino }) },
    
    { title: "Cantidad", cell: x => ({ data: x.cantidad }) },
    { title: "Peso", cell: x => ({ data: x.Peso }) },
    { title: "Dimensiones", cell: x => ({ 
    data:
        x.Alto > 0 && x.Largo > 0 && x.Ancho >0 ? x.Alto +"-"+x.Largo+"-"+x.Ancho : ""
    }) },
    { title: "Contenido", cell: x => ({ data: x.Contenido }) },
    { title: "Descripcion", cell: x => ({ data: x.Descripcion }) },
    { title: "Nombre Camion", cell: x => ({ data: x.NombreCamion }) },
    { title: "Nombre Caja", cell: x => ({ data: x.NombreCaja }) },


];

/**Obtiene las columnas del grid */
export function columnas(): Column[] {
    return [...columnasFijas];
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/consultaMovimientosCarga/list/cargasdescargas/columnas.tsx